import { LANGUAGES_SELECT_VALUES, LOCALES } from '@/_constants';
import { TLanguage } from './_types';

export const LANGUAGES_LIST: Array<TLanguage> = [
  {
    id: LOCALES.RU,
    title: LANGUAGES_SELECT_VALUES.ru,
    selectTitle: LANGUAGES_SELECT_VALUES.ruShort,
  },
  {
    id: LOCALES.EN,
    title: LANGUAGES_SELECT_VALUES.en,
    selectTitle: LANGUAGES_SELECT_VALUES.enShort,
  },
  {
    id: LOCALES.ZH,
    title: LANGUAGES_SELECT_VALUES.zh,
    selectTitle: LANGUAGES_SELECT_VALUES.zhShort,
  },
  {
    id: LOCALES.KA,
    title: LANGUAGES_SELECT_VALUES.ka,
    selectTitle: LANGUAGES_SELECT_VALUES.kaShort,
  },
  {
    id: LOCALES.TR,
    title: LANGUAGES_SELECT_VALUES.tr,
    selectTitle: LANGUAGES_SELECT_VALUES.trShort,
  },
  {
    id: LOCALES.TG,
    title: LANGUAGES_SELECT_VALUES.tg,
    selectTitle: LANGUAGES_SELECT_VALUES.tgShort,
  },
];
